// extracted by mini-css-extract-plugin
export default {"perk":"CrewPoints_perk"};